import React from 'react'
import getText from '../strings'
import { SubmitButton } from '../../application'
import styled from 'react-emotion'
import WizardButtons from './WizardButtons'

const Wrapper = styled('div')`
  label {
    display: block;
    font-weight: bold;
    margin: 10px 0 0 0;
  }
`

const ProcessTime = styled('div')`
  margin: 20px 0;
`

const FlexRow = styled('div')`
  display: flex;
  justify-content: space-between;
  >div {
    width: calc(50% - 10px);
  }
  @media (max-width: 992px) {
    flex-direction: column;
    >div {
      width: 100%;
    }
  }
`

export default ({ sending, onBackClick, onNextClick, formData: { bookingNumbers = [], firstName, lastName, birthDate, mobile, email } }) => (
  <Wrapper>
    <FlexRow>
      <div>
        <label>{getText('wizard', 'step3', 'fullName')}</label>
        {firstName} {lastName}
      </div>
      <div>
        <label>{getText('wizard', 'step3', 'birthDate')}</label>
        {birthDate}
      </div>
    </FlexRow>
    <FlexRow>
      <div>
        <label>{getText('wizard', 'step3', 'email')}</label>
        {email}
      </div>
      <div>
        <label>{getText('wizard', 'step3', 'mobilePhone')}</label>
        {mobile}
      </div>
    </FlexRow>
    <FlexRow>
      <div>
        <label>{getText('wizard', 'step3', 'myTrips')}</label>
        {bookingNumbers.join(', ') || '-'}
      </div>
    </FlexRow>
    <ProcessTime>
      {getText('wizard', 'step3', 'processTimeForCase')} <strong>{getText('wizard', 'step3', 'processTime')}</strong>
    </ProcessTime>
    <WizardButtons>
      <button disabled={sending} onClick={onBackClick} className="btn ghost-blue" type="button">{getText('wizard', 'step3', 'back')}</button>
      <button
        className="btn btn-function"
        type="button"
        disabled={sending}
        onClick={onNextClick}>
        {getText('wizard', 'step3', 'submit')}
      </button>
    </WizardButtons>
  </Wrapper>
)